import buildPath from './path-builder'
import { isVan } from '../../category-matcher'

export default (vehicle) => {
  const categoryImg = isVan(vehicle.category)
    ? 'van-placeholder'
    : 'placeholder'
  const image = vehicle.image ? vehicle.image : categoryImg

  const isSold = vehicle.expiredDate || vehicle.isSold
  const price = isSold ? 'Vehicle Sold' : { total: Number(vehicle.value) }
  const category = isVan(vehicle.category) ? 'van' : 'car'

  return {
    model: `${vehicle.model}`,
    make: `${vehicle.brand}`,
    price,
    path: buildPath(category, vehicle),
    category: vehicle.category,
    image,
    details: [
      vehicle.mileage && vehicle.mileage.toLocaleString() + ' MILES',
      vehicle.fuel
    ].filter((value) => !!value)
  }
}
